import React from "react";
import Footer from "./Footer.js";
import Navbar from "./SpectraNavbar.js";

const StatusPage = ({ icon, title, badge, children, footer }) => {
  return (
    <div className='flex-container'>
      <Navbar />
      <div
        className='px-sm-3 px-lg-5 py-3 full-height'
        style={{ marginTop: "79px" }}
      >
        <div className='shadow card full-height'>
          <div className='card-body full-height d-flex flex-column justify-content-around'>
            <div className='d-flex flex-column align-items-center flex-wrap text-center'>
              <div
                className='display-1 shadow text-white d-flex justify-content-center align-items-center mb-4'
                style={{
                  background: "#1ca3f0",
                  borderRadius: "50%",
                  width: "120px",
                  height: "120px",
                }}
              >
                <i className={`bi ${icon}`}></i>
              </div>
              {badge}
              <h1>{title}</h1>
              {children}
              <div className='d-flex gap-2'>
                <button
                  className='btn btn-outline-primary mt-3'
                  onClick={() => window.history.back()}
                >
                  Go Back
                </button>
                <button
                  className='btn btn-secondary mt-3'
                  onClick={() => {
                    window.location.href = "/";
                  }}
                >
                  Go to Home
                </button>
              </div>
              {footer}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StatusPage;
